import { useCallback } from "react";

import { useLocalStorage } from "./useLocalStorage";

const STORAGE_KEY = "p0-dismissed-announcements";

type DismissedAnnouncements = Record<string, boolean>;

/**
 * Hook to manage dismissed state for announcement banners.
 * Persists dismiss state to localStorage so dismissed banners
 * don't reappear on page refresh.
 *
 * @param id - Unique identifier for the announcement
 * @returns Tuple of [isDismissed, dismiss function]
 */
export function useDismissedAnnouncement(id: string): [boolean, () => void] {
  const [dismissed, setDismissed] = useLocalStorage<DismissedAnnouncements>(
    STORAGE_KEY,
    {}
  );

  const isDismissed = dismissed[id] ?? false;

  const dismiss = useCallback(() => {
    setDismissed((prev) => ({
      ...prev,
      [id]: true,
    }));
  }, [id, setDismissed]);

  return [isDismissed, dismiss];
}
